module.exports = __webpack_public_path__ + "assets/img/custody-abt.2eca3928.png";